import { RectNode, RectNodeModel, h } from '@logicflow/core';
import { getThemeStyle } from '../theme';

class DataObjectReferenceView extends RectNode {
  getShape() {
    const { model } = this.props;
    const { x, y, width, height } = model;
    const style = model.getNodeStyle();

    const left = x - width / 2;
    const top = y - height / 2;
    const fold = 10;

    // Document shape with folded corner (5-point polygon)
    const outline = `M ${left} ${top} L ${left + width - fold} ${top} L ${left + width} ${top + fold} L ${left + width} ${top + height} L ${left} ${top + height} Z`;
    const foldPath = `M ${left + width - fold} ${top} L ${left + width - fold} ${top + fold} L ${left + width} ${top + fold}`;

    return h('g', {}, [
      h('path', {
        d: outline,
        ...style,
      }),
      h('path', {
        d: foldPath,
        fill: 'none',
        stroke: style.stroke,
        strokeWidth: style.strokeWidth,
      }),
    ]);
  }
}

class DataObjectReferenceModel extends RectNodeModel {
  initNodeData(data) {
    super.initNodeData(data);
    this.width = 36;
    this.height = 50;
  }

  getNodeStyle() {
    const style = super.getNodeStyle();
    const t = getThemeStyle(this.graphModel, 'dataObjectReference');
    style.stroke = t.stroke || '#555';
    style.strokeWidth = t.strokeWidth ?? 1.5;
    style.fill = t.fill || '#fff';
    return style;
  }
}

export const DataObjectReference = {
  type: 'epx:DataObjectReference',
  view: DataObjectReferenceView,
  model: DataObjectReferenceModel,
};
